var SETTINGS = {
	APP_VERSION: 1,
	LANGUAGE: "fr",
	BASE_URL: window.location.protocol + "//" + window.location.host + "/",
	CURRENT_URL: window.location.protocol + "//" + window.location.host + window.location.pathname,
	API_URL: null, // if needed
	CDN_URL: null, // if needed
	VERSIONNING: new Date().getTime(), //for caching
	DEVICE: "computer", // if needed
	IS_MOBILE: false, // if needed
	IS_TABLET: false, // if needed
	DEBUG_MODE: false // turn false if you wanna disable console.
};

SETTINGS.ISIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

if (window.caspian) {
	SETTINGS.LANGUAGE    = caspian.appLanguage;
	SETTINGS.APP_URL     = caspian.siteUrl;
	SETTINGS.APP_ASSETS  = caspian.assetsPath;

	SETTINGS.PHP_DEVICE  = (caspian.device) ? caspian.device : "computer";
	SETTINGS.PHP_MOBILE  = (SETTINGS.PHP_DEVICE && SETTINGS.PHP_DEVICE == "phone") ? true : false;
	SETTINGS.PHP_TABLET  = (SETTINGS.PHP_DEVICE && SETTINGS.PHP_DEVICE == "tablet") ? true : false;

	SETTINGS.DEVICE      = (SETTINGS.PHP_DEVICE) ? SETTINGS.PHP_DEVICE : "computer";
	SETTINGS.IS_MOBILE   = (SETTINGS.PHP_DEVICE && SETTINGS.PHP_DEVICE == "phone") ? true : false;
	SETTINGS.IS_TABLET   = (SETTINGS.PHP_DEVICE && SETTINGS.PHP_DEVICE == "tablet") ? true : false;

    SETTINGS.MOUSE_OVER_EVENT   = SETTINGS.PHP_DEVICE == "computer" ? 'mouseenter' : 'touchstart';
    SETTINGS.MOUSE_OUT_EVENT    = SETTINGS.PHP_DEVICE == "computer" ? 'mouseleave' : 'touchend';
}

window.frenchRegex = /^[a-z ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜ àáâãäåæçèéêëìíîïòóôõöùúûü \-'’]*$/i;